import { Component, OnInit, OnChanges } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
@Component({
  selector: 'page-formulario43',
  templateUrl: './formulario43.component.html',
  styleUrls: ['./formulario43.component.css']
})
export class Formulario43Component implements OnInit {
  public nombreMuni = GLOBAL.nombreMuni;
  public region = GLOBAL.region;
  public propiedad;
  public propietarios;
  public permiso_notariado;
  public arquitectos;
  public loteo_const;
  public mod_parcial;
  public caract_proy_mod;
  public caract_solicitud;
  public registro_bienes;
  public caract_anteproy_loteo;
  public lotes_enajenar;
  public tipo_garantia;
  public caract_sol;
  public cuenta_con_mod;

  //contadores

  public sup_proy_total = 0;
  public cant = 0;
  public sup_porcentajes = 0;
 
  

   pages = [1,2,3];

  constructor() {

  


  }

   ngOnInit(){

   }

   ngAfterContentChecked(){


    this.ngAfterContentInit();
    
  }

  ngDoCheck(){
    this.sup_proy_total = 0;

    //LOTES ENAJENAR
    if(JSON.parse(localStorage.getItem("lotes_enajenar"))){
      if (JSON.parse(localStorage.getItem("lotes_enajenar")).length > 0){
        this.lotes_enajenar = JSON.parse(localStorage.getItem("lotes_enajenar"))
      }else{ 
      localStorage.setItem("lotes_enajenar", JSON.stringify([]))
        this.lotes_enajenar = [{lotes_enajenar:'',num_lotes:'',sup_lotes_enajenar:'', hoja_anexa:''}]
      }
    }


    for (let i = 0; i < this.lotes_enajenar.length; i++) {
      
      this.sup_proy_total = this.sup_proy_total + parseInt(this.lotes_enajenar[i].sup_lotes_enajenar);
    }
  }

   ngAfterContentInit() {
    
  
    //PROPIEDAD
    if (JSON.parse(localStorage.getItem("propiedad"))){ 
      this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
    }else{
     localStorage.setItem("propiedad", JSON.stringify([]))
      this.propiedad = [{rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa:'', direc_complemento:'', direc_compl_num:'', loteo:'', manzana:'', plano:'', recordId:''}]
    }

    //PROPIETARIOS
    if (JSON.parse(localStorage.getItem("propietarios"))){
        this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
     }else{
        localStorage.setItem("propietarios", JSON.stringify([]))
        this.propietarios = [{rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''}]
     }

     //PERMISO NOTARIADO
    if (JSON.parse(localStorage.getItem("permiso_notariado"))){
      this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
    }else{
     localStorage.setItem("permiso_notariado", JSON.stringify([]))
      this.permiso_notariado = [{acreditacion:'', fecha:null, escritura:null, notario:''}]
    }

    //ARQUITECTOS
    if (JSON.parse(localStorage.getItem("arquitectos"))){
      this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"))
    }else{ 
     localStorage.setItem("arquitectos", JSON.stringify([]))
      this.arquitectos = [{rut: '', nombre:'', mail:'', apellido_mat:'', apellido_pat:'', direccion: '', direccion_complemento:'', direccion_num:'', comuna:'', fono:'', fax:'',  patente:'', recordId:''}]
    }

    //REGISTRO DE BIENES
    if (JSON.parse(localStorage.getItem("registro_bienes"))){
      this.registro_bienes = JSON.parse(localStorage.getItem("registro_bienes"))
    }else{ 
     localStorage.setItem("registro_bienes", JSON.stringify([]))
      this.registro_bienes = [{inscrito: '', numero:'', anio:'', bienes:''}]
    }


     //LOTES ENAJENAR
     if (JSON.parse(localStorage.getItem("lotes_enajenar"))){
      this.lotes_enajenar = JSON.parse(localStorage.getItem("lotes_enajenar"))
    }else{ 
     localStorage.setItem("lotes_enajenar", JSON.stringify([]))
      this.lotes_enajenar = [{lotes_enajenar:'',num_lotes:'',sup_lotes_enajenar:'', hoja_anexa:''}]
    }
    
    //TIPO GARANTIA
    if (JSON.parse(localStorage.getItem("tipo_garantia"))){
      this.tipo_garantia = JSON.parse(localStorage.getItem("tipo_garantia"))
    }else{ 
     localStorage.setItem("tipo_garantia", JSON.stringify([]))
      this.tipo_garantia = [{tipo_garantia:''}]
    }
    
    //CARACTERISTICAS SOL
    if (JSON.parse(localStorage.getItem("caract_sol"))){
      this.caract_sol = JSON.parse(localStorage.getItem("caract_sol"))
    }else{ 
     localStorage.setItem("caract_sol", JSON.stringify([]))
      this.caract_sol = [{num_reso_perm:'',fecha_reso_perm:null, tipo_garantia:''}]
    }

    //CUENTA CON MOD
    if (JSON.parse(localStorage.getItem("cuenta_con_mod"))){
      this.cuenta_con_mod = JSON.parse(localStorage.getItem("cuenta_con_mod"))
    }else{ 
     localStorage.setItem("cuenta_con_mod", JSON.stringify([]))
      this.cuenta_con_mod = [{mod_aprob:'', numero:'', fecha:null }]
    }
    


  }

  captureScreen(){
    var pdf = new jspdf('p', 'mm', 'a4');

    html2canvas(document.getElementById(`page1`)).then(canvas => {
       const contentDataURL = canvas.toDataURL('image/png')
       pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });

    html2canvas(document.getElementById(`page2`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });
    html2canvas(document.getElementById(`page3`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)  
    });
    setTimeout(() =>{
      pdf.save(this.propietarios[0].rut+'.pdf')
     // pdf.save('prueba.pdf')
    },6000)
   }
}

